import { getApiUrl, getHeaders, getPrivateApiHeaders } from '@Utils/core/api/apiConfiguration';
import createApi, { Decorator, Api } from './createApi';

interface Options extends RequestInit {
  headers: {
    cookie: string;
    app_id: string;
    theme_id: string;
  };
}

function getUrl(url: string) {
  return `${getApiUrl()}${url}`;
}

const decorator: Decorator<Options> = (config) => ({
  ...config,
  headers: {
    ...getHeaders(),
    ...getPrivateApiHeaders(),
    cookie: config.headers ? config.headers.cookie : '',
    // eslint-disable-next-line @typescript-eslint/camelcase
    app_id: config.headers.app_id,
    // eslint-disable-next-line @typescript-eslint/camelcase
    theme_id: config.headers.theme_id,
  },
  credentials: 'include',
});
const defaultApi: Api = createApi(decorator, getUrl);

export default defaultApi;
